export default __webpack_public_path__ + "static/media/sc21.a12a5eed.jpg";